import { LogoutService } from "../Infrastructure/Auth.service";
/* import store from "../../Redux/store";
import { setUserModel } from "../../User/Infrastructure/User.reducer";
import { setAdviserModel } from "../../Adviser/Infrastructure/Adviser.reducer";
import { setBusinessPartnerModel } from "../../BusinessPartner/Infrastructure/BusinessPartner.reducer"; */

export default async function LogoutLogic() {
  return LogoutService();
  /* localStorage.removeItem("userid");
  // localStorage.removeItem("zone");
  store.dispatch(setUserModel({}));
  store.dispatch(setAdviserModel({}));
  store.dispatch(setBusinessPartnerModel({})); */
}
